import { co2 } from './common';

export default {
  'consumption.co2': `${co2} emissioni combinate`,
  'consumption.energy': 'Consumo di energia nel ciclo di prova combinato',
  'consumption.fuel': 'Consumo di carburante combinato',
  'footnotes.local': '',
  'footnotes.wltp': `Il consumo di carburante/corrente è misurato secondo la normativa 715/2007/CE come modificata dalla versione attualmente in vigore. I valori indicati relativi al consumo di energia e alle emissioni di ${co2} sono valori svizzeri sulla base dell'omologazione. Si tratta di valori che sono stati rilevati nell'ambito del ciclo di misurazione WLTP. I consumi possono variare a seconda dello stile di guida, delle condizioni del fondo stradale e del traffico, delle condizioni meteorologiche e dello stato della vettura. I dati non si riferiscono a una singola vettura e non fanno parte dell'offerta, ma sono forniti esclusivamente a titolo di confronto tra i diversi modelli. Per rendere paragonabili i consumi di energia dei diversi tipi di motori (benzina, gasolio, gas, corrente ecc.), sono riportati anche i cosiddetti equivalenti benzina (unità di misura per l'energia). Il ${co2} è il gas a effetto serra maggiormente responsabile del riscaldamento della Terra; per il 2021 l'emissione media di ${co2} di tutti i modelli proposti (per tutti i marchi) è di 169 g/km.`,
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': `Weitere Informationen über den offiziellen Kraftstoffverbrauch und die ${co2}-Emissionen neuer Personenkraftwagen erhalten Sie bei Ihrem Mercedes-Benz Vertragshändler.`,
  'search.input.label': 'Il vostro termine di ricerca / OnlineCode Configurator',
  'search.result.buy-online': 'Acquista Online',
  'search.results': 'Nessun risultato trovato. | {count}  Risultato della ricerca | {count}  Risultati della ricerca',
  'search.results.count': '{count}  Risultati della ricerca',
  'search.results.backup': 'Non sono state trovate corrispondenze esatte. Visualizza le pagine correlate:',
  'search.results.none.summary':
    'Non ci sono risultati di ricerca disponibili per questo termine di ricerca. Riprovare con un termine diverso.',
  'search.show-more': 'Mostra di più',
  'search.unavailable': 'La ricerca non è attualmente disponibile.',
  'search.result.new': 'Nuovo',

  'input.placeholder': 'Il vostro termine di ricerca / OnlineCode Configurator',

  'search.result.consumption': 'Consumi',
  'watch.video': 'Guarda il video',
  'input.recently': 'Ricerche recenti',
  'input.help.title': 'Cosa dovresti cercare?',
  'input.help.text':
    'Effettua la ricerca utilizzando tipi di veicoli, modelli, codici di configurazione oppure accessori, altri prodotti e altre informazionion',

  all: 'Tutte',
  UCOS: 'Modelli usati',
  PASSENGER_CARS: 'Autovettura',
  VANS: 'Monovolume',
  NCOS: 'Scegli in pronta consegna',
  VIDEO: 'Video',
  DEALER_LOCATOR: 'Ricerca concessionaria',
  CONFIGURATOR: 'Configurare la vettura',
  TEST_DRIVE: 'Test drive',
  VEHICLE_SEARCH: 'Ricerca vetture usate',
  COLLECT: 'Collezione & Accessori',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'Accessoires de voiture',

  'search.result.grid': 'Grid',
  'search.result.list': 'List',

  // No results
  'support.check': "Veuillez vérifier les fautes d'orthographe ou réessayer avec une autre frase",
  'support.no.results': "Aucun résultat de recherche n'est disponibile pour ce terme de recherche.",
  'support.no.results.term': 'Aucun risultato',
  'support.chat': 'Vous ne trouvez pas ce que vous cherchez? Veuillez utente non supporta la',
  'support.chat.with.us': 'chat in linea.',

  'search.results.offer': 'Offerte popolari per "{query}":',
};
